<template>
	<div class="sdkBox">
		<div class="main" style="padding: 0;">
			<div class="headTabs">
				<el-tabs v-model="activeTab" @tab-click="tabChange">
					<el-tab-pane label="Android" value="1" name="1"></el-tab-pane>
					<!-- <el-tab-pane label="IOS" value="2" name="2"></el-tab-pane> -->
				</el-tabs>
			</div>
		</div>
		<div class="main" v-for="(item,index) in sdkIntegralLists" :key="index">
			<table>
				<tbody>
					<tr>
						<td class="tdLeft">
							<p class="p1">SDK名称</p>
						</td>
						<td>
							<p class="p1">{{item.name}}</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">开发者</p>
						</td>
						<td>
							<p class="p1">{{item.developer}}</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">SDK 版本</p>
						</td>
						<td>
							<p class="p1">{{item.version}}</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">功能介绍</p>
						</td>
						<td>
							<p class="p1">{{item.function}}</p>
						</td>
					</tr>

					<tr>
						<td colspan="2">
							<div class="space_around">
								<div class="linkBox flex_start" @click="linkDoc(item.docUrl)">
									<img src="../../assets/images/iconDoc.png" alt="" />
									<div>接入文档</div>
								</div>
								<div class="linkBox flex_start" @click="linkDoc(item.privateUrl)">
									<img src="../../assets/images/iconPrivacy.png" alt="" />
									<div>隐私政策</div>
								</div>
								<div class="linkBox flex_start" @click="linkDoc(item.guideUrl)">
									<img src="../../assets/images/iconGRC.png" alt="" />
									<div>合规指引</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="downloadBtn flex_end">
				<el-button class="el-button" type="primary" @click="downloadSDK(item.downloadUrl)" size="small" v-hasPermi="['accessCenter:SDKIntegration:download']">下载SDK</el-button>
			</div>
		</div>
		<!-- <div class="main">
			<table>
				<tbody>
					<tr>
						<td class="tdLeft">
							<p class="p1">SDK名称</p>
						</td>
						<td>
							<p class="p1">RichMob Android SDK</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">开发者</p>
						</td>
						<td>
							<p class="p1">杭州互裕科技有限公司</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">SDK 版本</p>
						</td>
						<td>
							<p class="p1">3.3.4</p>
						</td>
					</tr>
					<tr>
						<td class="tdLeft">
							<p class="p1">功能介绍</p>
						</td>
						<td>
							<p class="p1">为您提供App流量变现服务</p>
						</td>
					</tr>
		
					<tr>
						<td colspan="2">
							<div class="space_around">
								<div class="linkBox flex_start" @click="linkDoc(4)">
									<img src="../../assets/images/iconDoc.png" alt="" />
									<div>接入文档</div>
								</div>
								<div class="linkBox flex_start" @click="linkDoc(5)">
									<img src="../../assets/images/iconPrivacy.png" alt="" />
									<div>隐私政策</div>
								</div>
								<div class="linkBox flex_start" @click="linkDoc(6)">
									<img src="../../assets/images/iconGRC.png" alt="" />
									<div>合规指引</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="downloadBtn flex_end">
				<el-button class="el-button" type="primary" @click="downloadSDK(2)" size="small">下载SDK</el-button>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: '1',
				// accessDoc: require('../../assets/file/RichMore-Android.pdf'),
				sdkIntegralLists: []
			}
		},
		mounted(){
			this.getSDKIntegralList();
		},
		methods: {
			tabChange(tab, event) {},
			async getSDKIntegralList(){
				let res = await this.$http.post(this.$api.common.sdkIntegralList);
				this.sdkIntegralLists = res.data
			},
			linkDoc(link){
				if(link){
					window.open(link, '_blank');
				}
				// if(type == 1){
				// 	window.open('https://file.ssp.richmob.cn/sdk/apk/RichMore-Android%E6%8E%A5%E5%85%A5%E6%96%87%E6%A1%A3.pdf', '_blank');
				// }else if(type == 2){
				// 	window.open('https://file.ssp.richmob.cn/privacy/privacy-sdkrule.html', '_blank');
				// }else if(type == 3){
				// 	window.open('https://file.ssp.richmob.cn/privacy/privacy-po-richmore.html', '_blank');
				// }else if(type == 4){
				// 	window.open('https://file.ssp.richmob.cn/sdk/apk/Richmob%E5%B9%BF%E5%91%8ASDK%E5%AF%B9%E6%8E%A5%E6%96%87%E6%A1%A3.pdf', '_blank');
				// }else if(type == 5){
				// 	window.open('https://file.ssp.richmob.cn/privacy/privacy-prorules.html', '_blank');
				// }else if(type == 6){
				// 	window.open('https://file.ssp.richmob.cn/privacy/privacy-po-richmob.html', '_blank');
				// }
			},
			downloadSDK(link){
				if(link){
					location.href = link
				}
				// if(type == 1){
				// 	location.href = 'https://file.ssp.richmob.cn/sdk/apk/richmore-1.8.4.aar'
				// }else if(type == 2){
				// 	location.href = 'https://file.ssp.richmob.cn/sdk/apk/richmob-3.3.4.aar'
				// }
			},
		},
	}
</script>

<style scoped>
	.sdkBox{
		margin: 10px;
	}
	.main {
		background: #FFFFFF;
		width: 100%;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 32px;
		margin-bottom: 10px;
		box-sizing: border-box;
	}

	.headTabs {
		/* margin-bottom: 10px; */
		font-size: 16px;
		margin: 0 40px;
	}
	/deep/ .el-tabs__header{
		margin-bottom: 0;
	}
	/* 使用 /deep/ 选择器覆盖 Element UI 的默认样式 */
	/deep/ .el-tabs__nav-wrap::after {
	  height: 0; /* 移除底部的边框线 */
	}
	/deep/ .el-tabs__item {
		height: 54px;
		line-height: 54px;
		font-size: 16px;
		color: #007FFF;
	}
	/deep/.el-tabs__active-bar{
		background-color: #007FFF;
	}

	table {
		border: 1px solid #EBEAEB;
		border-collapse: collapse;
		width: 100%;
		table-layout: fixed;

	}

	td {
		border: 1px solid #EBEAEB;
		padding: 15px;
		min-width: 100px;
		font-size: 14px;
	}

	.p1 {
		line-height: 20px;
		margin: 0;
	}
	.tdLeft{
		width: 226px;
		background: #F9F9FA;
	}
	.linkBox{
		cursor: pointer;
		align-items: center;
	}
	.linkBox img{
		width: 24px;
		height: 24px;
		margin-right: 3px;
	}
	.linkBox div{
		line-height: 20px;
		/* margin-top: 2px; */
		/* height: 22px; */
	}
	.downloadBtn{
		margin-top: 25px;
	}
</style>